export default "__VITE_ASSET__DXCnmVMF__"